import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import PageHeadingNew from "../../components/common-components/custom-comps/PageHeadingNew";
import TrainerBCAEvaluationTable from "../../components/trainer-report/trainer-bca-evaluation/TrainerBCAEvaluationTable";
import TrainerStatsDetailTable from "../../components/trainer-report/trainer-bca-evaluation/TrainerStatsDetailTable";
import { fetchTrainerStatsData } from "../../redux/prospect-reducers/prospectSlice";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import { isManagerRole } from "../../components/common-data/Conversions";
import DetailModHeader from "../../components/common-components/DetailModHeader";

const TrainerBCAEvaluation = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManager = isManagerRole(userInfoData?.email);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedTrainer: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    filterType: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  function getTrainerStats(filters) {
    dispatch(
      fetchTrainerStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getTrainerStats(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
    }));
  }, [isPage, pageLimit, allFilters.selectedGym, allFilters.selectedTrainer]);

  return (
    <HelmetWrapper title="WTF: Trainer BCA Evaluation">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          <div className="createNewCTOModalContainer mod-width-95vw mod-height-95vh">
            <DetailModHeader
              info={modValues.rowData}
              onClose={onCloseModal}
              isOnlySubscription={true}
              from="tme-analysis"
              filterType={modValues.filterType}
            />

            {modValues.modName === "view_details" ? (
              <TrainerStatsDetailTable
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                filterType={modValues.filterType}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <PageHeadingNew
              heading="Trainer BCA Evaluation"
              subheading="View and track trainer BCA and fitness profile statistics"
              onReload={() => getTrainerStats(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="trainer-bca-evaluation"
              userInfoData={userInfoData}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickReset={onResetFilters}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <TrainerBCAEvaluationTable
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default TrainerBCAEvaluation;
